export interface Option {
  value: string | number;
  label: string;
}

interface OptionsProxy {
  raw: Option[];
}

export const rawOptions = (options: unknown): Option[] => (options as OptionsProxy).raw;

export const optionLabel = (options: unknown, value: unknown): string | undefined => (
  rawOptions(options).find((option) => option.value === value)?.label
);

export const optionLabels = (options: unknown, values: unknown): string[] => {
  if (!Array.isArray(values)) return [];

  return rawOptions(options)
    .filter((option) => values.includes(option.value))
    .map((option) => option.label);
};
